// Language support. English lives at the root (/products), Spanish under /es (/es/products).
// All page copy lives in ./en and ./es as plain objects with the same shape, so either
// language can be edited without touching the components.
import { useLocation } from 'react-router-dom';
import en from './en';
import es from './es';

export const LANGUAGES = {
  en: { label: 'English', short: 'EN', htmlLang: 'en' },
  es: { label: 'Español', short: 'ES', htmlLang: 'es' },
};

const content = { en, es };

export const langFromPath = (pathname) =>
  pathname === '/es' || pathname.startsWith('/es/') ? 'es' : 'en';

// "/es/products" -> "/products"; English paths are returned unchanged.
// A trailing slash is dropped, since static hosts may redirect "/products" to "/products/".
export const stripLang = (pathname) => {
  const trimmed = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return langFromPath(trimmed) === 'es' ? trimmed.replace(/^\/es/, '') || '/' : trimmed;
};

// "/products" -> "/es/products" when lang is "es"
export const localizePath = (path, lang) => {
  if (lang === 'en') return path;
  return path === '/' ? '/es' : `/es${path}`;
};

export function useLang() {
  return langFromPath(useLocation().pathname);
}

// Returns a function that turns an English path into the current language's path
export function useLocalizePath() {
  const lang = useLang();
  return (path) => localizePath(path, lang);
}

// Copy for one section of the site (e.g. useContent('products')) in the current language
export function useContent(section) {
  return content[useLang()][section];
}
